import { render, staticRenderFns } from "./SystemUnion.vue?vue&type=template&id=583a09ee&scoped=true"
import script from "./SystemUnion.vue?vue&type=script&lang=js"
export * from "./SystemUnion.vue?vue&type=script&lang=js"
import style0 from "./SystemUnion.vue?vue&type=style&index=0&id=583a09ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583a09ee",
  null
  
)

export default component.exports